import React from "react";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";

const DarkTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#1e1e2d",
    color: "#fff",
    fontSize: "13px",
    borderRadius: "8px",
    padding: "10px 14px",
    maxWidth: 320,
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
    lineHeight: 1.5,
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: "#1e1e2d",
  },
}));

const HoverTruncatedText = ({ text, maxLength = 30, className = "" }) => {
  if (!text) {
    return <span className={className}>-</span>;
  }

  if (text.length <= maxLength) {
    return <span className={className}>{text}</span>;
  }

  const truncated = `${text.substring(0, maxLength)}...`;

  return (
    <DarkTooltip title={text} placement="top" arrow>
      <span
        className={className}
        style={{ wordBreak: "break-word" }}
      >
        {truncated}
      </span>
    </DarkTooltip>
  );
};

export default HoverTruncatedText;
